import { useNavigate, useSearch } from "@tanstack/react-router";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AlertsView } from "./alerts-view";
import { UserReportsView } from "./user-reports/user-reports-view";

type RiskFlaggingView = "alerts" | "reports";

export function RiskFlaggingPage() {
  const navigate = useNavigate();
  const {
    view: viewParam,
    alertId,
    reportId,
  } = useSearch({ from: "/_authenticated/risk-flagging/" });

  const view: RiskFlaggingView = reportId
    ? "reports"
    : alertId
      ? "alerts"
      : (viewParam ?? "alerts");

  const handleViewChange = (v: string) => {
    navigate({
      to: "/risk-flagging",
      search: { view: v as RiskFlaggingView },
      replace: true,
    });
  };

  return (
    <div className="px-[80px] py-[60px] font-body">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Risk flagging</h1>
        <p className="text-muted-foreground">
          Review moments of potential risk detected by the system
        </p>
      </div>

      <Tabs
        value={view}
        onValueChange={handleViewChange}
        className="mb-4 flex items-center"
      >
        <TabsList className="rounded-[10px] border border-zinc-200 bg-[#F5F4F2] p-1">
          <TabsTrigger
            value="alerts"
            className="rounded-[8px] px-5 py-1.5 text-zinc-500 data-[state=active]:bg-white data-[state=active]:text-zinc-900 data-[state=active]:shadow-none"
          >
            Moderation alerts
          </TabsTrigger>
          <TabsTrigger
            value="reports"
            className="rounded-[8px] px-5 py-1.5 text-zinc-500 data-[state=active]:bg-white data-[state=active]:text-zinc-900 data-[state=active]:shadow-none"
          >
            User reports
          </TabsTrigger>
        </TabsList>
      </Tabs>

      {view === "reports" && <UserReportsView deepLinkedReportId={reportId} />}
      {view === "alerts" && <AlertsView deepLinkedAlertId={alertId} />}
    </div>
  );
}
